export default __webpack_public_path__ + "static/media/box-img-1.5c1e3395.svg";